function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { MediaType } from '../utils/media';
/**
 * 미디어 아이템 렌더러 훅
 * 
 * 미디어 아이템 유형별 렌더링 처리를 담당합니다.
 */ export function useMediaItemRenderer() {
    /**
   * 미디어 아이템 렌더링 함수
   */ var renderMediaItem = function(media, index, isFirstItem, mediaType, isNormalVideo, isShortFormVideo, positionClass, handleMediaClick) {
        // 공통 props
        var commonProps = {
            mediaUrl: media,
            index: index,
            className: positionClass,
            onClick: function() {
                return handleMediaClick(media, index, mediaType);
            }
        };
        // 비디오 타입 동적 import
        var VideoItem = /*#__PURE__*/ React.lazy(function() {
            return import('../components/ContentMediaGrid/components/VideoItem');
        });
        // 이미지 타입 동적 import
        var ImageItem = /*#__PURE__*/ React.lazy(function() {
            return import('../components/ContentMediaGrid/components/ImageItem');
        });
        // 기타 미디어 타입 동적 import
        var OtherMediaItem = /*#__PURE__*/ React.lazy(function() {
            return import('../components/ContentMediaGrid/components/OtherMediaItem');
        });
        // React.Suspense로 감싸서 lazy 로딩 처리
        var fallback = /*#__PURE__*/ React.createElement("div", {
            className: "".concat(positionClass, " bg-gray-100 animate-pulse")
        });
        // 미디어 타입에 따라 다른 컴포넌트 렌더링
        if (isNormalVideo) {
            return /*#__PURE__*/ React.createElement(React.Suspense, {
                fallback: fallback
            }, /*#__PURE__*/ React.createElement(VideoItem, _object_spread_props(_object_spread({
                key: media
            }, commonProps), {
                isShortForm: false,
                isNormalVideo: true
            })));
        } else if (isShortFormVideo) {
            return /*#__PURE__*/ React.createElement(React.Suspense, {
                fallback: fallback
            }, /*#__PURE__*/ React.createElement(VideoItem, _object_spread_props(_object_spread({
                key: media
            }, commonProps), {
                isShortForm: true,
                isNormalVideo: false
            })));
        } else if (mediaType === MediaType.IMAGE) {
            return /*#__PURE__*/ React.createElement(React.Suspense, {
                fallback: fallback
            }, /*#__PURE__*/ React.createElement(ImageItem, _object_spread({
                key: media
            }, commonProps)));
        } else if (mediaType === MediaType.VIDEO) {
            return /*#__PURE__*/ React.createElement(React.Suspense, {
                fallback: fallback
            }, /*#__PURE__*/ React.createElement(VideoItem, _object_spread_props(_object_spread({
                key: media
            }, commonProps), {
                isShortForm: false,
                isNormalVideo: true
            })));
        } else {
            return /*#__PURE__*/ React.createElement(React.Suspense, {
                fallback: fallback
            }, /*#__PURE__*/ React.createElement(OtherMediaItem, _object_spread_props(_object_spread({
                key: media
            }, commonProps), {
                mediaType: mediaType
            })));
        }
    };
    return {
        renderMediaItem: renderMediaItem
    };
}
export default useMediaItemRenderer;
